<template>
  <div>
    <AuxiliaryCoolingEquipment />
  </div>
</template>

<script>
import AuxiliaryCoolingEquipment from "@/components/AuxiliaryCoolingEquipment/index.vue";
export default {
  components: {
    AuxiliaryCoolingEquipment,
  },
};
</script>

<style></style>
